import {
  UPDATE_GPT_RECOMMENDATION_LOG_PAGE_NUMBER,
  GET_GPT_RECOMMENDATION_LOG_PENDING,
  GET_GPT_RECOMMENDATION_LOG,
  DELETE_GPT_RECOMMENDATION_LOG,
  FETCH_GPT_RECOMMENDATION_LOG,
  EDIT_GPT_RECOMMENDATION_LOG,
  ADD_GPT_RECOMMENDATION_LOG,
  CLEAR_GPT_RECOMMENDATION_LOG,
  CLEAR_ALL,
} from "constants/actions";

const initialState = {
  gpt_recommendation: [],
  deleted: null,
  updated: null,
  pending: false,
  pageNumber: 1,
};

export default function GptRecommendation(state = initialState, action) {
  switch (action.type) {
    case GET_GPT_RECOMMENDATION_LOG_PENDING:
      return {
        ...state,
        pending: true,
      };
      
    case UPDATE_GPT_RECOMMENDATION_LOG_PAGE_NUMBER:
      return {
          ...state,
          pageNumber: action.payload,
        };

    case GET_GPT_RECOMMENDATION_LOG:
      return {
        ...state,
        gpt_recommendation: action.payload,
        pending: false,
      };

    case FETCH_GPT_RECOMMENDATION_LOG:
      return { 
          ...state, 
          [action.payload.id]: action.payload, 
          pending: false 
        };

    case EDIT_GPT_RECOMMENDATION_LOG:
      return { 
        ...state, 
        updated: action.payload,
        pending: false,
      };

    case DELETE_GPT_RECOMMENDATION_LOG:
      return {
        ...state,
        deleted: action.payload,
        pending: false,
      };

    case ADD_GPT_RECOMMENDATION_LOG:
      return {
        ...state,
        gpt_recommendation: [...state.gpt_recommendation, action.payload],
        pending: false,
      };

    case CLEAR_GPT_RECOMMENDATION_LOG:
      return {
        ...state,
        ...initialState,
      };

    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
